import { render, staticRenderFns } from "./wangEditor.vue?vue&type=template&id=6c36fccf&scoped=true"
import script from "./wangEditor.vue?vue&type=script&lang=js"
export * from "./wangEditor.vue?vue&type=script&lang=js"
import style0 from "./wangEditor.vue?vue&type=style&index=0&id=6c36fccf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c36fccf",
  null
  
)

export default component.exports